export const ParkingStatus = [
    { value: "Todos", name: "Todos" },
    { value: true, name: "Finalizados" },
    { value: false, name: "Não finalizados" },
];